import React, { useEffect, useState } from "react";
import { ProdesegDropdownToggle } from "../../../../components/prodeseg-dropdown/ProdesegDropdownToggle";
import { PolicyMenuItem } from "../../menu/PolicyMenuItem";
import { ProdesegDropdownMenu } from "../../../../components/prodeseg-dropdown/ProdesegDropdownMenu";
import { ProdesegButtonEnumTypes } from "../../../../components/ProdesegButton/ProdesegButton";
import { ProdesegDropdown } from "../../../../components/prodeseg-dropdown/ProdesegDropdown";
import { ReactComponent as IconPro } from "../../../../assets/img/icon/menu/pro.svg";
import { ExecutiveData } from "./ExecutiveData";
import { useExecutives } from "../../../../custom-hooks/useExecutives";
import { find_ramos } from "../../../../api/CacheApi";
import { LineOfBusiness } from "../../../../interface/line-of-business.interface";
import { useWindowBreakpoints } from "../../../../custom-hooks/useWindowBreakpoints";

export const PolicyExecutives = () => {
    const [linesOfBusiness, setLinesOfBusiness] = useState<LineOfBusiness[]>([]);
    const { policyExecutives } = useExecutives();
    const { isDownMd } = useWindowBreakpoints();

    useEffect(() => {
        let isMounted = true;
        find_ramos().then(linesOfBusiness => {
            if (isMounted) setLinesOfBusiness(linesOfBusiness);
        });

        return () => {
            isMounted = false;
        };
    }, []);

    if (!policyExecutives.length) return null;

    return (
        <ProdesegDropdown position={"top"} align={"center"} disableBodyScroll>
            <ProdesegDropdownToggle>
                <PolicyMenuItem
                    policy={{
                        title: "Ejecutivo Prodeseg",
                        icon: IconPro,
                        isDisabled: false,
                    }}
                    itemHeight={"auto"}
                    iconTheme={"dark"}
                />
            </ProdesegDropdownToggle>
            <ProdesegDropdownMenu
                showCloseButton
                iconCloseStyle={{ right: "6px", top: "2px" }}
                iconCloseButtonType={ProdesegButtonEnumTypes.Primary}
                activateModal={isDownMd}
            >
                <div
                    className="d-flex flex-column py-4 pl-4 pr-4-2 gap-4"
                    style={{ maxHeight: isDownMd ? "auto" : "400px" }}
                >
                    <div className="d-flex gap-3">
                        <IconPro width="32px" height="32px" />
                        <span className="fs-4 fw-semibold">
                            <span className="text-primary-700">Ejecutivos </span>
                            <span className="text-primary-950">Prodeseg</span>
                        </span>
                    </div>
                    <div className="d-flex flex-column gap-4">
                        {policyExecutives.map((executive, index) => (
                            <React.Fragment key={executive.fullName + executive.idLineOfBusiness}>
                                <ExecutiveData executive={executive} linesOfBusiness={linesOfBusiness} />
                                {index < policyExecutives.length - 1 ? (
                                    <div className={"announcement__separator"} />
                                ) : null}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </ProdesegDropdownMenu>
        </ProdesegDropdown>
    );
};
